<div class="row">
    <!-- START: Banner card -->
    <div class="col-12">
        <div class="card">
            <div class="card-header banner rounded rounded-bottom-0 align-content-center">
                <div class="row">
                    <div class="col-12">
                        <div class="fs-2hx fw-bolder lh-sm">{{user?.firstName}},</div>
                        <div class="fs-1 lh-sm">{{'WELCOME_TO_YOUR_ENERGY_MARKET' | translate}}</div>
                    </div>
                </div>
            </div>
            <div class="card-body">

                <div class="row">
                    <!-- HEDGING Market -->
                    <div class="col-6">
                        <div class="card rounded overflow-hidden position-relative mb-5">
                            <div class="position-absolute card-sidebar hedging"></div>
                            <div class="card-body mt-3">
                                <div class="d-flex justify-content-center">
                                    <img class="rounded mb-3" src="https://energia.mastervantagem.com/wp-content/uploads/2025/05/Hedging-1.png" width="60px" height="60px">
                                </div>
                                <div class="text-center w-100 fs-1 fw-bolder">{{'HEDGING_MARKET' | translate}}</div>
                                <div class="text-center mb-5 w-100 fs-4">{{'HEDGING_MARKET_DESCRIPTION' | translate}}</div>
                                
                                <div class="fs-5"><i class="fas fa-check me-2"></i>{{'HEDGING_MARKET_DESCRIPTION_LINE_1' | translate}}</div>
                                <div class="fs-5"><i class="fas fa-check me-2"></i>{{'HEDGING_MARKET_DESCRIPTION_LINE_2' | translate}}</div>
                                <div class="fs-5"><i class="fas fa-check me-2"></i>{{'HEDGING_MARKET_DESCRIPTION_LINE_3' | translate}}</div>
                                <hr>
                                <div>{{'IDEAL_FOR' | translate}}</div>
                                <div class="fs-5">{{'IDEAL_FOR_DESCRIPTION_HEDGING' | translate}}</div>
                                <div class="d-flex justify-content-end mt-8">
                                    <div class="btn btn-light-primary rounded-pill py-3 px-6" (click)="navigateTo('hedging')">{{'LEARN_MORE' | translate}}<i class="ms-4 fas fa-arrow-right"></i></div>
                                </div>
                            </div>
                        </div>

                        <div class="border border-solid border-active-primary rounded p-5 px-8 blur price">
                            <!-- START: Title -->
                            <div class="row mb-5">
                                <div class="col-12 fw-bold text-primary fs-1">
                                    {{ 'HIGHLIGHTED_PRICE' | translate }} ⭐
                                </div>
                            </div>
                            <!-- END: Title -->
                            <!-- START: Price -->
                            <div class="row">
                                <div class="col-10">
                                    <div class="row gx-0">
                                        <div class="col-4">
                                            <div class="border border-solid p-3 lh-1 bg-secondary rounded rounded-end-0">
                                                <div>{{ 'FROM' | translate }} </div>
                                                <div> 
                                                    <span class="fw-800 fs-2qx"> 35 </span> 
                                                    <span class="fs-4"> €/MWh </span> 
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-8 border border-solid py-2 px-3 rounded rounded-start-0 align-content-center">
                                            <div class="row fs-7 gy-1">
                                                <div class="col-6">
                                                    <div class="d-flex justify-content-between">
                                                        <span class=""> {{ 'STANDARD' | translate }}</span>
                                                        <span class="fw-bold"> 35€/MWh </span>
                                                    </div>
                                                </div>
                                                <div class="col-6">
                                                    <div class="d-flex justify-content-between">
                                                        <span class=""> {{ 'OFF_PEAK' | translate }}</span>
                                                        <span class="fw-bold"> 35€/MWh </span>
                                                    </div>
                                                </div>
                                                <div class="col-6">
                                                    <div class="d-flex justify-content-between">
                                                        <span class=""> {{ 'PEAK' | translate }}</span>
                                                        <span class="fw-bold"> 35€/MWh </span>
                                                    </div>
                                                </div>
                                                <div class="col-6">
                                                    <div class="d-flex justify-content-between">
                                                        <span class=""> {{ 'SUPER_OFF_PEAK_ABBREVIATED' | translate }}</span>
                                                        <span class="fw-bold"> 35€/MWh </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-2 fs-2 fw-bold btn border border-solid btn-light-success border-success-subtle rounded d-flex align-items-center justify-content-center">
                                    {{ 'SIMULATE' | translate }}
                                </div>
                            </div>
                            <!-- END: Price -->
                            <!-- START: Details -->
                            <div class="row gy-3 my-5">
                                <div class="col-5">
                                    <div> {{'PERIOD' | translate }}</div>
                                    <div class="fw-bolder"> Q2 2025 - Q3 2026 </div>
                                </div>
                                <div class="col-5">
                                    <div> {{'PRICE_VALIDITY' | translate }}</div>
                                    <div class="fw-bolder"> {{'HIRE_UNTIL' | translate}} {{ '02/23/2026' | date: 'shortDate' }} </div>
                                </div>
                                <div class="col-5">
                                    <div> {{'CONTRACTED_MWH_LIMIT' | translate }}</div>
                                    <div class="fw-bolder"> 9 GWh </div>
                                </div>
                                <div class="col-5">
                                    <div> {{'SUPPLIER' | translate }}</div>
                                    <div class="fw-bolder"> Audax </div>
                                </div>
                                <div class="col-12">
                                    <div> {{'CONSUMPTION_INTEREST' | translate }}</div>
                                    <div class="w-100 rounded bg-secondary mt-1">
                                        <div class="w-75 h-100 rounded rounded-end-0 bg-light-warning text-warning py-1 ps-2">
                                            <span>
                                                <i class="fal fa-circle-info"></i>
                                            </span>
                                            <span> {{ 'ONLY_X_REMAINING_AVAILABLE_MWH' | translate: { x: 3 } }}</span>
                                        </div>
                                    </div>
                                    <div class="w-100 position-relative">
                                        <span style="position:absolute; left: calc(75% - 5.5ch)" class="fw-bold fs-7 text-gray-600">6 GWh</span>
                                        <span style="position:relative; left: calc(100% - 5.5ch)" class="fw-bold fs-7 text-gray-400">9 GWh</span>
                                    </div>
                                </div>
                            </div>
                            <!-- END: Details -->
                            <!-- START: Button -->
                            <div class="row mt-10">
                                <div class="col-12">
                                    <span> 
                                        <i class="fas fa-circle-info"></i>
                                    </span>
                                    <span>
                                        {{ 'ECONOMIC_CONDITIONS' | translate }}
                                    </span>
                                </div>
                            </div>
                            <!-- END: Button -->
                            <div class="row mt-3">
                                <div class="col-12">
                                    <a [routerLink]="'/market-dealers/hedging'">
                                        <div class="btn btn-primary rounded w-100 text-center fw-bolder fs-5">
                                            {{ 'I_AM_INTERESTED' | translate }}
                                        </div> 
                                    </a>
                                     
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- SPOT Market -->
                    <div class="col-6">
                        
                        <div class="card rounded overflow-hidden position-relative mb-5">
                            <div class="position-absolute card-sidebar spot"></div>
                            <div class="card-body mt-3">
                                <div class="d-flex justify-content-center">
                                    <img class="rounded mb-3" src="https://energia.mastervantagem.com/wp-content/uploads/2025/05/Spot-1.png" width="60px" height="60px">
                                </div>
                                <div class="text-center w-100 fs-1 fw-bolder">{{'SPOT_MARKET' | translate}}</div>
                                <div class="text-center mb-5 w-100 fs-4">{{'SPOT_MARKET_DESCRIPTION' | translate}}</div>
                                
                                <div class="fs-5"><i class="fas fa-check me-2"></i>{{'SPOT_MARKET_DESCRIPTION_LINE_1' | translate}}</div>
                                <div class="fs-5"><i class="fas fa-check me-2"></i>{{'SPOT_MARKET_DESCRIPTION_LINE_2' | translate}}</div>
                                <div class="fs-5"><i class="fas fa-check me-2"></i>{{'SPOT_MARKET_DESCRIPTION_LINE_3' | translate}}</div>
                                <hr>
                                <div>{{'IDEAL_FOR' | translate}}</div>
                                <div class="fs-5">{{'IDEAL_FOR_DESCRIPTION_SPOT' | translate}}</div>
                                <div class="d-flex justify-content-end mt-8">
                                    <span [matTooltip]="('IN_DEVELOPMENT' | translate)" style="cursor: not-allowed">
                                        <div class="btn btn-light-warning rounded-pill py-3 px-6 disabled">{{'LEARN_MORE' | translate}}<i class="ms-4 fas fa-arrow-right"></i></div>
                                    </span>
                                </div>
                            </div>
                        </div>

                        <div class="border border-solid border-active-primary rounded p-5 px-8 blur price">
                            <!-- START: Title -->
                            <div class="row mb-5">
                                <div class="col-12 fw-bold text-primary fs-1">
                                    {{ 'HIGHLIGHTED_PRICE' | translate }} ⭐
                                </div>
                            </div>
                            <!-- END: Title -->
                            <!-- START: Price -->
                            <div class="row">
                                <div class="col-10">
                                    <div class="row gx-0">
                                        <div class="col-4">
                                            <div class="border border-solid p-3 lh-1 bg-secondary rounded rounded-end-0">
                                                <div>{{ 'FROM' | translate }} </div>
                                                <div> 
                                                    <span class="fw-800 fs-2qx"> 35 </span> 
                                                    <span class="fs-4"> €/MWh </span> 
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-8 border border-solid py-2 px-3 rounded rounded-start-0 align-content-center">
                                            <div class="row fs-7 gy-1">
                                                <div class="col-6">
                                                    <div class="d-flex justify-content-between">
                                                        <span class=""> {{ 'STANDARD' | translate }}</span>
                                                        <span class="fw-bold"> 35€/MWh </span>
                                                    </div>
                                                </div>
                                                <div class="col-6">
                                                    <div class="d-flex justify-content-between">
                                                        <span class=""> {{ 'OFF_PEAK' | translate }}</span>
                                                        <span class="fw-bold"> 35€/MWh </span>
                                                    </div>
                                                </div>
                                                <div class="col-6">
                                                    <div class="d-flex justify-content-between">
                                                        <span class=""> {{ 'PEAK' | translate }}</span>
                                                        <span class="fw-bold"> 35€/MWh </span>
                                                    </div>
                                                </div>
                                                <div class="col-6">
                                                    <div class="d-flex justify-content-between">
                                                        <span class=""> {{ 'SUPER_OFF_PEAK_ABBREVIATED' | translate }}</span>
                                                        <span class="fw-bold"> 35€/MWh </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-2 fs-2 fw-bold btn border border-solid btn-light-success border-success-subtle rounded d-flex align-items-center justify-content-center">
                                    {{ 'SIMULATE' | translate }}
                                </div>
                            </div>
                            <!-- END: Price -->
                            <!-- START: Details -->
                            <div class="row gy-3 my-5">
                                <div class="col-5">
                                    <div> {{'PERIOD' | translate }}</div>
                                    <div class="fw-bolder"> Q2 2025 - Q3 2026 </div>
                                </div>
                                <div class="col-5">
                                    <div> {{'PRICE_VALIDITY' | translate }}</div>
                                    <div class="fw-bolder"> {{'HIRE_UNTIL' | translate}} {{ '02/23/2026' | date: 'shortDate' }} </div>
                                </div>
                                <div class="col-5">
                                    <div> {{'CONTRACTED_MWH_LIMIT' | translate }}</div>
                                    <div class="fw-bolder"> 9 GWh </div>
                                </div>
                                <div class="col-5">
                                    <div> {{'SUPPLIER' | translate }}</div>
                                    <div class="fw-bolder"> Audax </div>
                                </div>
                                <div class="col-12">
                                    <div> {{'CONSUMPTION_INTEREST' | translate }}</div>
                                    <div class="w-100 rounded bg-secondary mt-1">
                                        <div class="w-75 h-100 rounded rounded-end-0 bg-light-warning text-warning py-1 ps-2">
                                            <span>
                                                <i class="fal fa-circle-info"></i>
                                            </span>
                                            <span> {{ 'ONLY_X_REMAINING_AVAILABLE_MWH' | translate: { x: 3 } }}</span>
                                        </div>
                                    </div>
                                    <div class="w-100 position-relative">
                                        <span style="position:absolute; left: calc(75% - 5.5ch)" class="fw-bold fs-7 text-gray-600">6 GWh</span>
                                        <span style="position:relative; left: calc(100% - 5.5ch)" class="fw-bold fs-7 text-gray-400">9 GWh</span>
                                    </div>
                                </div>
                            </div>
                            <!-- END: Details -->
                            <!-- START: Button -->
                            <div class="row mt-10">
                                <div class="col-12">
                                    <span> 
                                        <i class="fas fa-circle-info"></i>
                                    </span>
                                    <span>
                                        {{ 'ECONOMIC_CONDITIONS' | translate }}
                                    </span>
                                </div>
                            </div>
                            <!-- END: Button -->
                            <div class="row mt-3">
                                <div class="col-12">
                                    <div [matTooltip]="('IN_DEVELOPMENT' | translate)" style="cursor: not-allowed">
                                        <div class="btn btn-primary rounded w-100 text-center fw-bolder fs-5 disabled">
                                            {{ 'I_AM_INTERESTED' | translate }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <hr class="mt-5">
                <!-- <div class="prices-timetable mt-5" *ngIf="requestsCompleteFlag">
                    <app-custom-timeline-chart #ganttTimetable [items]="priceItems" [groups]="groups" [viewOptions]="viewOptions" [viewType]="viewTypes.year">
                        <ng-template #group let-group="group">
                            {{ group.title }}
                        </ng-template>
                        <ng-template #bar let-item="item">
                            <div class="timeline-item" [ngClass]="getTimelineItemClass(item)">{{ item.title }}</div>
                        </ng-template>
                    </app-custom-timeline-chart>
                </div> -->

            </div>
        </div>
    </div>
    <!-- END: Banner card -->
</div>